import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Container,
  Row,
  Spinner,
} from 'reactstrap';
import MateriaPeriodoForm from './MateriaPeriodoForm';
import {
  get,
  save,
  fetchFormDatas,
  fetchSubjectsScheduleBySubjectPeriodId,
  downloadSubjectStudentsScore,
  getSubjectStudents,
} from '../../../../redux/actions/materiaPeriodoActions';
import {
  createErrorMessage,
  createSuccessMessage,
  createWarningMessage,
} from '../../../../helpers/notification';

import LoadingSpinner from '../../../../shared/components/LoadingSpinner';

class MateriaPeriodoContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tipoActividadAcademicaHorarios: [],
      diasSemana: [],
      loading: false,
      horarios: [],
      horarioChanged: 0,
      loadingAlumnosMateria: false,
      items: [],
      totalItemsCount: 0,
      filters: {
        page: 1,
        pageSize: 20,
        numeroDocumento: '',
        nombreAlumno: '',
        apellidoAlumno: '',
      },
    };
  }

  componentDidMount() {
    this.fetchCurrentRecord();
    this.updateSubjectsScheduleTable();
  }

  downloadAlumnosMateriaNotas = () => {
    const { id } = this.props;
    this.setState({ loadingAlumnosMateria: true });
    downloadSubjectStudentsScore({
      id,
      onSuccess: () => {
        this.setState({ loadingAlumnosMateria: false });
        createSuccessMessage('Lista descargada exitosamente');
      },
      onError: () => {
        this.setState({ loadingAlumnosMateria: false });
        createErrorMessage('Error al intentar descargar la lista de calificaciones alumnos');
      },
    });
  }

  updateAlumnosMateria = (page, pageSize, filters) => {
    const { id } = this.props;

    this.setState({
      loadingAlumnosMateria: true,
      filters: filters || {},
    });

    getSubjectStudents({
      filters,
      id,
      onSuccess: ({ materias: items }) => {
        this.setState({
          loadingAlumnosMateria: false,
          items,
          totalItemsCount: items.length,
        });
      },
      onError: () => {
        this.setState({
          items: [],
          loadingAlumnosMateria: false,
        });
        createErrorMessage('Error al intentar cargar la lista de alumnos');
      },
    });
  }

  fetchCurrentRecord = () => {
    const { id, idPeriodo, history } = this.props;
    if (id) {
      get({
        id,
        onSuccess: (dto) => {
          this.setState({ materiaPeriodo: dto });
          this.fetchDatasList(dto.malla.value);
        },
        onError: (error) => {
          if (error && error.status === 404) {
            createErrorMessage('La materia periodo no existe');
            history.push(`/pages/periodos/edit/${idPeriodo}`);
          } else {
            createErrorMessage('Error al intentar cargar los datos de la materia periodo');
          }
        },
      });
    } else {
      this.setState({
        materiaPeriodo: {
          id: 0,
          fecha: new Date().toISOString(),
          utilizaPorcentajePesoMateria: false,
        },
      });
    }
  }

  fetchDatasList = (mallaId) => {
    fetchFormDatas({
      mallaId,
      onSuccess: ({
        mallas,
        materias,
        periodos,
        profesores,
        tipoActividadAcademicaHorarios,
        diasSemana,
      }) => {
        this.setState({
          mallas,
          materias,
          periodos,
          profesores,
          tipoActividadAcademicaHorarios,
          diasSemana,
        });
      },
      onError: () => {
        createErrorMessage('Error al intentar cargar los datos requeridos');
      },
    });
  }

  handleSubmit = (values) => {
    if (!values) return;
    const {
      id,
      materia,
      profesor,
      profesorAuxiliar1,
      profesorAuxiliar2,
      profesorAuxiliar3,
      materiaMallaId,
      malla,
      periodoId,
      horarios,
      utilizaPorcentajePesoMateria,
      editarAsistencias,
      seccion,
    } = values;
    // const { value: materiaPeriodoId } = materia;
    const { value: mallaId } = malla;
    const { value: materiaId } = materia;
    const { value: profesorId } = profesor;
    const { value: profesorAuxiliar1Id } = profesorAuxiliar1 || {};
    const { value: profesorAuxiliar2Id } = profesorAuxiliar2 || {};
    const { value: profesorAuxiliar3Id } = profesorAuxiliar3 || {};

    const params = {
      // ...values,
      id,
      materiaMallaId,
      mallaId,
      materiaId,
      profesorId,
      periodoId,
      profesorAuxiliar1Id,
      profesorAuxiliar2Id,
      profesorAuxiliar3Id,
      horarios,
      utilizaPorcentajePesoMateria,
      editarAsistencias,
      seccion,
    };
    const { history, idPeriodo } = this.props;
    save(params, {
      onSuccess: () => {
        createSuccessMessage('Materia por periodo guardada exitosamente');
        history.push(`/pages/periodos/edit/${idPeriodo}`);
      },
      onError: (error) => {
        if (error.message) {
          createWarningMessage(error.message);
        } else {
          createErrorMessage('Ocurrió un error al intentar guardar la materia periodo');
        }
      },
    });
  }

  handleOnBack = () => {
    const { history } = this.props;
    history.goBack();
  }

  handleAddSubjectsSchedule = () => {
    const { horarios = [] } = this.state;

    const newIndex = horarios.length === 0 ? 0 : (Math.max(...horarios.map(({ index }) => index)) + 1);

    this.setState({
      horarios: [
        ...horarios,
        {
          id: 0,
          index: newIndex,
          materiaPeriodo: '',
          profesor: {
            value: 0,
            label: '-',
            parentId: 0,
            item: null,
          },
          dia: {
            value: 0,
            label: '-',
            parentId: 0,
            item: null,
          },
          horaInicio: '00:00',
          horaFin: '00:00',
          aula: '',
          tipoActividadAcademicaHorario: {
            value: 0,
            label: '-',
            parentId: 0,
            item: null,
          },
        },
      ],
    });
  }

  handleDeleteSubjectSchedule = ({ index }) => {
    const { horarios = [] } = this.state;
    const newArray = horarios.map(h => ({
      ...h,
      deleted: h.deleted || h.index === index,
    }));

    this.setState({ horarios: newArray });
  }

  updateSubjectsScheduleTable = () => {
    const { id } = this.props;

    if (!id) {
      this.setState({
        horarios: [],
      });

      return;
    }

    this.setState({
      loading: true,
    });

    fetchSubjectsScheduleBySubjectPeriodId({
      subjectId: id,
      onSuccess: (horarios) => {
        this.setState({
          loading: false,
          horarios: horarios.map((h, index) => ({ ...h, index })),
        });
      },
      onError: (error) => {
        this.setState({ horarios: [], loading: false });
        if (error && error.status === 404) {
          createErrorMessage('La horario de clases no existe');
        } else {
          createErrorMessage('Error al intentar cargar los datos del horario de clases');
        }
      },
    });
  }

  handleChangeText = (e, index) => {
    const { horarios } = this.state;

    const value = e.target.type === 'number' ? Number(e.target.value) : `${e.target.value}`.trim();

    const newHorarios = [...horarios];
    newHorarios[index] = {
      ...newHorarios[index],
      ...{
        [e.target.name.split('.')[1]]: value,
      },
    };

    this.setState({ horarios: newHorarios });
  };

  handleChangeSelect = ({ option, name, index }) => {
    this.setState({ loading: true });

    const { horarios } = this.state;
    const newHorarios = [...horarios];
    const data = {
      [name]: option,
      index,
    };

    newHorarios[index] = {
      ...newHorarios[index],
      ...data,
    };

    this.setState({
      horarios: newHorarios,
      loading: false,
      horarioChanged: new Date().getTime(),
    });
  };

  handleOnFilterChanges = (objectKey, idKey, item) => {
    const { materiaPeriodo } = this.state;

    this.setState({
      materiaPeriodo: {
        ...materiaPeriodo,
        [idKey]: item.value,
        [objectKey]: item,
      },
    });
  }

  showSpinner = () => (
    <div className="form__form-group text-center">
      <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
    </div>
  );

  render() {
    const { id, history } = this.props;
    const {
      materiaPeriodo,
      profesores,
      mallas,
      periodos,
      materias,
      tipoActividadAcademicaHorarios,
      diasSemana,
      loading,
      horarios,
      horarioChanged,

      loadingAlumnosMateria,
      items,
      filters = { pageSize: 250 },
      totalItemsCount,
    } = this.state;

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">
              {id ? 'Editar' : 'Nueva'} materia periodo
            </h3>
            <h3 className="page-subhead subhead">
              {id ? 'Modificar ' : 'Ingresa '}
              la materia periodo
            </h3>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            {!(profesores && materiaPeriodo)
              ? <LoadingSpinner />
              : (
                <MateriaPeriodoForm
                  {...materiaPeriodo}
                  onSubmit={this.handleSubmit}
                  onBack={this.handleOnBack}
                  materiaPeriodo={materiaPeriodo}
                  initialValues={materiaPeriodo}
                  history={history}
                  profesores={profesores}
                  materias={materias}
                  mallas={mallas}
                  periodos={periodos}
                  onFilterChanges={this.handleOnFilterChanges}
                  onSubjectChanges={this.handleOnSubjectChange}
                  handleDeleteInscription={this.handleDeleteInscription}

                  loading={loading}

                  tipoActividadAcademicaHorarios={tipoActividadAcademicaHorarios}
                  diasSemana={diasSemana}

                  horarioChanged={horarioChanged}

                  onChangeText={this.handleChangeText}
                  onChangeSelect={this.handleChangeSelect}

                  onAddSubjectsSchedule={this.handleAddSubjectsSchedule}
                  onDeleteSubjectSchedule={this.handleDeleteSubjectSchedule}

                  onGetAlumnosMateria={this.updateAlumnosMateria}
                  onDownloadAlumnosMateriaNotas={this.downloadAlumnosMateriaNotas}

                  showSpinner={this.showSpinner}

                  horarios={horarios}

                  loadingAlumnosMateria={loadingAlumnosMateria}
                  items={items}
                  totalItemsCount={totalItemsCount}
                  filters={filters}

                  enableReinitialize
                />
              )
            }
          </Col>
        </Row>
      </Container>
    );
  }
}

MateriaPeriodoContainer.propTypes = {
  id: PropTypes.string.isRequired,
  idPeriodo: PropTypes.string.isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default MateriaPeriodoContainer;
